export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('#menu-header-navigation li.dropdown .nav-link').click(function(e) {
            if ($(window).width() < 1200) {
                var grandparent = $(this).next();
                if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
                    document.location.href = this.href;
                } else {

                    $('#menu-header-navigation').find('i').removeClass('opened');
                    $(this).next('.dropdown-toggle1').click();
                }
            } else {
                location.href = this.href;
            }
            e.preventDefault();
        });

        $('li.dropdown > .dropdown-toggle1').on('click', function(e) {
            var current = $(this).next();
            var current1 = $(this);
            var grandparent = $(this).parent().parent();
            var cgrandparent = $(this).parent();
            grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
            grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
            grandparent.find('.nav-link').not(current1).removeClass('open1');
            $(this).toggleClass('opened');
            cgrandparent.find('.nav-link').toggleClass('open1');
            current.toggleClass('show1');
            e.stopPropagation();
        });
        // hide our element on page load
        $('.alignright').css('opacity', 0);

        $('.alignright').waypoint(function() {
            $('.alignright').addClass('fadeInRight');
        }, {
            offset: '100%',
        });

        $('.service-1').css('opacity', 0);

        $('.service-1').waypoint(function() {
            $('.service-1').addClass('fadeInLeft');
        }, {
            offset: '100%',
        });

        $('.service-2').css('opacity', 0);

        $('.service-2').waypoint(function() {
            $('.service-2').addClass('fadeInUp');
        }, {
            offset: '75%',
        });

        $('.service-3').css('opacity', 0);

        $('.service-3').waypoint(function() {
            $('.service-3').addClass('fadeInRight');
        }, {
            offset: '50%',
        });

        $('.faq-1').css('opacity', 0);

        $('.faq-1').waypoint(function() {
            $('.faq-1').addClass('fadeInLeft');
        }, {
            offset: '100%',
        });

        $('.faq-2').css('opacity', 0);

        $('.faq-2').waypoint(function() {
            $('.faq-2').addClass('fadeInUpBig');
        }, {
            offset: '75%',
        });

        $('.faq-3').css('opacity', 0);

        $('.faq-3').waypoint(function() {
            $('.faq-3').addClass('fadeInRight');
        }, {
            offset: '50%',
        });

        outsideToHash();

        function anchorScroll(fragment) {
            'use strict';
            var ttarget;
            ttarget = $('#' + fragment);
            $('html,body').animate({
                scrollTop: ttarget.offset().top - 160,
            }, 250);
            return false;
        }

        function outsideToHash() {
            'use strict';
            var fragment;
            if (window.location.hash) {
                fragment = window.location.hash.substring(1);
                anchorScroll(fragment);
            }
        }

    },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js